module.exports = __webpack_public_path__ + "img/WEBANK-FPD.60462e93.png";